import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { RFErrorNode, RFHandle } from '../kit';
import { isLogicalPort } from '../utils';
const useNodeTemplate = ({ id, templateCode, selected, config }) => {
    const template = useMemo(() => {
        return config.templates.find((t) => t.code === templateCode) || null;
    }, [templateCode, config]);
    const isValidTemplate = useMemo(() => {
        return !!template;
    }, [template]);
    const renderPorts = useCallback((isConnectable, isInspector) => {
        return (_jsx(_Fragment, { children: template?.ports.map((port) => {
                const isLogical = isLogicalPort(port.id);
                return (_jsx(RFHandle, { id: port.id, type: port.type, name: port.name, position: port.position, isInspector: isInspector, isConnectable: isConnectable && !isLogical, connectionCount: port.connectionCount, style: { ...port.style } }, port.id));
            }) }));
    }, [template?.ports]);
    const renderError = useCallback(() => {
        return (_jsx(RFErrorNode, { nodeId: id, selected: selected, templateCode: templateCode, elementType: config.type }));
    }, [config.type, id, selected, templateCode]);
    return { isValidTemplate, template, renderPorts, renderError };
};
export { useNodeTemplate };
//# sourceMappingURL=useNodeTemplate.js.map